import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLightning: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"lightning, zap, flash, thunder"} maskId="square-filled-radius-0-stroke-1-IconLightning"><path d="M8.4954 2L2.67188 13H8.79563L5.5991 22.0568L22.3777 8H15.8113L18.8113 2H8.4954Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLightning;
